// @flow

import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import App from './App.jsx';

import './css/ClimaCooprinsem.css';


type T_ClimaCooprinsemProps = {
  app: App
};


type T_ClimaCooprinsemState = {
  codes: Array<string>,
  date1: ?Date,
  date2: ?Date,
  codes: string
}


const Fmt = global.Intl.DateTimeFormat;



export default class ClimaCooprinsem extends Component<T_ClimaCooprinsemProps, T_ClimaCooprinsemState> {
  state = {
    date1: null,
    date2: null,
    codes: ''
  };
  
  
  
  componentDidMount(): void {
    this.props.app.dlg_cooprinsem = this;
  }
  
  
  
  componentWillUnmount(): void {
    this.props.app.dlg_cooprinsem = null;
  }
  
  
  
  mod_date1 = (ev: SyntheticInputEvent<*>, date1: Date): void => this.setState({date1});
  mod_date2 = (ev: SyntheticInputEvent<*>, date2: Date): void => this.setState({date2});
  mod_codes = (ev: SyntheticInputEvent<*>             ): void => this.setState({codes: ev.target.value});
  
  
  
  good_codes(): boolean {
    if (! this.state.codes) {
      return false;
    }
    
    return /^[\d\s]+$/.test(this.state.codes);
  }
  
  
  
  get = (): void => {
    if ((! this.state.date1) || (! this.state.date2) || (! this.good_codes())) {
      return;
    }
    
    const m1 = moment(this.state.date1),
          m2 = moment(this.state.date2);
    
    if (m1.isSameOrAfter(m2)) {
      return;
    }
    
    const date1 = m1.format('YYYY-MM-DD'),
          date2 = m2.format('YYYY-MM-DD');
    
    console.log(date1, date2);
  };
  
  
  
  close = (): void => this.props.app.setState({ui_clima_cooprinsem: false});
  
  
  
  render() {
    const {date1, date2} = this.state;
    
    return (
      <div className='CsvCoopri'>
        <h1>Reporte climasense Cooprinsem</h1>
        
        <DatePicker hintText='Fecha de inicio'  DateTimeFormat={Fmt} locale='es' value={date1} onChange={this.mod_date1} />
        <DatePicker hintText='Fecha de término' DateTimeFormat={Fmt} locale='es' value={date2} onChange={this.mod_date2} />
        
        <h2>Códigos:</h2>
        
        <textarea rows='3' onChange={this.mod_codes} placeholder='Separe los códigos con espacios.'>
          {this.state.codes}
        </textarea>
        
        <div className='bts_coopri'>
          <RaisedButton label='Cerrar'  onClick={this.close} primary={false} />
          <RaisedButton label='Obtener' onClick={this.get}   primary={true}  />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ClimaCooprinsem.jsx